module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.lastname),
      expression: "search.lastname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.search.lastname)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.lastname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Vorname:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.firstname),
      expression: "search.firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Vorname"
    },
    domProps: {
      "value": (_vm.search.firstname)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Herkunftsort:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.origin),
      expression: "search.origin"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Herkunftsort"
    },
    domProps: {
      "value": (_vm.search.origin)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.origin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Semester:")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.semester),
      expression: "search.semester"
    }],
    attrs: {
      "name": "semester"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.semester = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.searchStudents()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.semesters), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('td', [_vm._v("Fakultät/Fach:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.faculty),
      expression: "search.faculty"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fakultät/Fach"
    },
    domProps: {
      "value": (_vm.search.faculty)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.faculty = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v("Gefunden: " + _vm._s(_vm.found.size || 0))])])]), _vm._v(" "), _vm._l((_vm.found.persons), function(item) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": item.id
      }
    }, [_vm._v(_vm._s(item.lastname) + " " + _vm._s(item.firstname))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origin))])])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/sources"
    }
  }, [_vm._v("Bio-bibliographische Nachweise")])], 1)])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('h1', [_vm._v("Datenbank durchsuchen:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e758593a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StudentList.vue
// module id = 93
// module chunks = 1